import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { SanitizeInputDirective } from './sanitize-input.directive';
import { LoaderComponent } from './loader/loader.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
@NgModule({
declarations: [SanitizeInputDirective,LoaderComponent],
imports:[
// Angular modules
CommonModule,FormsModule,ReactiveFormsModule,HttpClientModule,

// Angular Material modules
MatButtonModule,MatCardModule,MatCheckboxModule,MatDialogModule,MatExpansionModule,MatFormFieldModule,MatIconModule,MatInputModule,
MatListModule,MatMenuModule,MatPaginatorModule,MatSelectModule,MatSidenavModule,MatSlideToggleModule,MatSliderModule,MatSortModule,
MatTableModule,MatToolbarModule,MatTooltipModule,

// Third-party modules
NgxPaginationModule,PdfViewerModule,ToastrModule
],
exports:[
// Angular modules
CommonModule,FormsModule,ReactiveFormsModule,HttpClientModule,

// Angular Material modules
MatButtonModule,MatCardModule,MatCheckboxModule,MatDialogModule,MatExpansionModule,MatFormFieldModule,MatIconModule,MatInputModule,
MatListModule,MatMenuModule,MatPaginatorModule,MatSelectModule,MatSidenavModule,MatSlideToggleModule,MatSliderModule,MatSortModule,
MatTableModule,MatToolbarModule,MatTooltipModule,MatTabsModule,MatStepperModule,

// Third-party modules
NgxPaginationModule,PdfViewerModule,ToastrModule,

// Your custom directive
SanitizeInputDirective,LoaderComponent,
],
})

export class GlobalImportsModule { }